import { Button, toast } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon, HelpCircle } from "lucide-react";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useCreateKPI } from "../api/queries";
import { KPIFormTour, useKPIFormTour } from "../tour/KPIFormTour";
import { KPIForm } from "../ui/KPIForm";

export function KPICreatePage() {
  const nav = useNavigate({ from: "/app/kpi/create" });
  const createKPI = useCreateKPI();
  const tour = useKPIFormTour();

  return (
    <>
      <Header />
      <Main>
        <KPIFormTour run={tour.run} onCallback={tour.handleJoyrideCallback} />

        <div className="space-y-4">
          <div className="flex items-center justify-between gap-4">
            <div>
              <div className="flex items-center space-x-2">
                <h1 className="font-semibold text-2xl">ສ້າງ KPI ໃໝ່</h1>
                <Button
                  variant="ghost"
                  size="icon"
                  className="size-7 rounded-full"
                  onClick={tour.startTour}
                >
                  <HelpCircle className="size-5" />
                </Button>
              </div>
              <p className="mt-1 text-muted-foreground text-sm">
                ກຳນົດຕົວຊີ້ວັດຜົນການປະຕິບັດງານ (KPI) ໃໝ່ - ຕັ້ງ KPI ໄດ້ໃນ 3 ນາທີ
              </p>
            </div>

            <Button
              type="button"
              variant="ghost"
              size="sm"
              onClick={() => nav({ to: "/app/kpis" })}
            >
              <ArrowLeftIcon className="mr-2 h-4 w-4" />
              ກັບ
            </Button>
          </div>

          <div className="rounded-lg border bg-card p-6">
            <KPIForm
              variant="page"
              onSubmit={async (vals) => {
                await toast.promise(
                  createKPI.mutateAsync(
                    vals as Parameters<typeof createKPI.mutateAsync>[0],
                  ),
                  {
                    loading: "ກຳລັງບັນທຶກ...",
                    success: "ສ້າງ KPI ສຳເລັດ",
                    error: "ສ້າງ KPI ລົ້ມເຫຼວ",
                  },
                );
                nav({ to: "/app/kpis" });
              }}
              submitting={createKPI.isPending}
              isEdit={false}
            />
          </div>
        </div>
      </Main>
    </>
  );
}
